import * as React from 'react';
import { throttle } from '@cian/newbuilding-utils';
import { Header as HeaderComponent } from '../../components/Header';
import { PikLogo } from '../../components/PikLogo';
import { Callback } from '../Callback';
import { PikPhoneNumber } from '../PikPhoneNumber';
import { getPrevSiblingDistanceToTop } from './helpers';
import { ECallbackPlace } from '../../types/callback';

export function Header() {
  const [isHeaderFixed, setHeaderFixed] = React.useState(false);
  const headerRef = React.useRef<HTMLElement>(null);
  const headerHeight = headerRef.current ? headerRef.current.getBoundingClientRect().height : 0;
  const prevSiblingDistanceToTop = getPrevSiblingDistanceToTop(headerRef.current);
  const place = isHeaderFixed ? ECallbackPlace.BlockStickyTop : ECallbackPlace.HeadBlock;

  const handleFixHeader = React.useCallback(() => {
    const header = headerRef.current;

    /* istanbul ignore next */
    if (!header) {
      return;
    }

    const windowYOffset = window.pageYOffset;

    if (windowYOffset > prevSiblingDistanceToTop + headerHeight) {
      setHeaderFixed(true);
    } else {
      setHeaderFixed(false);
    }
  }, [headerHeight, prevSiblingDistanceToTop]);
  const handleScroll = throttle(200, handleFixHeader);

  React.useEffect(() => {
    handleFixHeader();
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleFixHeader, handleScroll]);

  return (
    <HeaderComponent
      ref={headerRef}
      isFixed={isHeaderFixed}
      logo={<PikLogo />}
      number={<PikPhoneNumber />}
      callback={<Callback place={place} />}
    />
  );
}
